//
//
//
//
//
//
//
//
//
//
//

import AllDialog from '@/components/publicComponents/allScreenDialog'
export default {
  name: 'Loading',
  components: {
    'my-alldialog': AllDialog
  },
  data () {
    return {

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/publicComponents/loading.vue